define(function(){
	const IPS = require('../base/ipsModelCollection')
	return IPS.extend({
		urlRoot : '/delegate/civics-api/api/cdr/common/applications/{0}/relatedapplications',
		url:function(){
      if (!this.appId)
        this.appId = 1;
			return this.urlRoot.format(this.appId);
		}
	});
});
